import md5 from 'md5';

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '祝你开心每一天！', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader (callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () {}
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

/**
 * @author yuping.pang
 * @date 2023-06-04 15:22
 * @param request 列表接口
 * @param params 列表传参
 * @param serialNumberIs 是否需要生成序号
 * @description  生成适应ls-table表格接口方法
**/
export function generateLsTableResData (request, serialNumberIs) {
  return params => {
    return new Promise((resolve, reject) => {
      params.pageNum = params.page;
      delete params.page;
      request(params).then(res => {
        const { total, rows } = res;
        if (serialNumberIs) {
          rows.map((item, index) => {
            item.serialNumber = (index + 1) + ((params.pageNum - 1) * params.pageSize)
          })
        }
        const { pageSize } = params
        const pages = Math.ceil(total / pageSize)
        resolve({
          data: {
            state: 100,
            data: {
              ...res,
              records: rows,
              pages,
              total
            }
          }
        })
      }).catch(err => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          msg: err,
          state: 103
        })
      })
    })
  }
}

/**
 * @author yuping.pang
 * @date 2023-06-04 15:22
 * @param request 列表接口
 * @param params 列表传参
 * @param serialNumberIs 是否需要生成序号
 * @description  生成适应ls-table表格接口方法（分页参数为pageSize、page，返回为{ code: 200, rows: [], total: 0 }的格式）
**/
export function generateLsTableResDataPageRowsVersion (request, serialNumberIs) {
  return params => {
    return new Promise((resolve, reject) => {
      request(params).then(res => {
        const { total, rows } = res;
        if (serialNumberIs) {
          rows.map((item, index) => {
            item.serialNumber = (index + 1) + ((params.pageNum - 1) * params.pageSize)
          })
        }
        const { pageSize } = params
        const pages = Math.ceil(total / pageSize)
        resolve({
          data: {
            state: 100,
            data: {
              records: rows,
              pages,
              total
            }
          }
        })
      }).catch(err => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject({
          msg: err,
          state: 103
        })
      })
    })
  }
}

// 用于把枚举list 转换为 map 编码 映射为中文
export function transferListToMap (list, keyName = 'value', valueName = 'label') {
  const result = {};
  if (Array.isArray(list)) {
    list.map(item => {
      result[item[keyName]] = valueName ? item[valueName] : item;
    })
  }
  return result;
}

// 用于把枚举 转换为 map 编码 映射为中文
export function transferEnumToMap (enums, keyName = 'value', valueName = 'label') {
  const result = {};
  let list = enums;
  if(Object.prototype.toString.call(enums) === '[object Object]') {
    list = Object.values(enums);
  }
  if (Array.isArray(list)) {
    list.map(item => {
      result[item[keyName]] = valueName ? item[valueName] : item;
    })
  }
  return result;
}

/*
 * @description: 批量处理从excel直接copy数据过来查询(注意，入参的原字段统一要加上Val后缀，如itemCodeVal)
 * @param {*} valField 原字段，如itemCode
 * @param {*} listField 转换成list字段，如itemCodes
 * @param {*} val 查询的query对象
 */
export function handleCopyFromExcel(valField, listField, val = {}) {
  const listVal = []
  if (val[valField + 'Val']) {
    const list = val[valField + 'Val'].split(' ')
    list.forEach((v, i) => {
      list[i] = v.replace(/[\n\r\s]+/g, '') // 去掉excel可能存在的空格换行符特殊字符
      if (list[i]) { listVal.push(list[i]) }
    })
  }
  if(listVal?.length > 1) {
    val[listField] = listVal
    delete val[valField]
  } else {
    val[valField] = listVal[0]
    delete val[listField]
  }
  return val
}

export function getFaDadaContractUrl(contractId) {
  const apiKey = process.env.VUE_APP_FA_DADA_API_KEY;
  const timestamp = new Date().getTime();
  const apiSecrt = process.env.VUE_APP_FA_DADA_API_SECRT;
  const sign = md5(apiKey.toString() + timestamp.toString() + apiSecrt.toString());
  return process.env.VUE_APP_API_FADADA_URL + `/api/v2/contract/view?apiKey=${apiKey}&timestamp=${timestamp}&sign=${sign}&contractId=${contractId}`;
}
